import moment from 'moment';

const ScheduleSabadoField = ({HorarioSabado}:any) => {
    const dateSplit = HorarioSabado ? HorarioSabado.split(' - ') : null;
    return (
        <div>
            <label>{ dateSplit ? moment(dateSplit[0]).format('hh:mm A') +" - "+moment(dateSplit[1]).format('hh:mm A') : ''}</label>
        </div>
    )
}

export default ScheduleSabadoField
